import { render, staticRenderFns } from "./TheRecipientsAreaUnrestrictedGiftLink.vue?vue&type=template&id=5f4501f6"
import script from "./TheRecipientsAreaUnrestrictedGiftLink.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAreaUnrestrictedGiftLink.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAreaUnrestrictedGiftLink.vue?vue&type=style&index=0&id=5f4501f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports